import React, { useContext, useEffect, useState } from 'react'
import { SubscriptionContext } from '../../context/subscription'
import { withTheme } from 'theming'
import Subscription from './subscription'
import BackIconImg from '../../assets/imgComponents/backIconImg'
import { useTranslation } from 'react-i18next'

const SubscriptionModal = ({ theme }) => {
  const { setOpenSubscriptionModal, setContentPartners } = useContext(SubscriptionContext)
  const { t } = useTranslation()

  // Animation state
  const [show, setShow] = useState(false)

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      setContentPartners([])
      setOpenSubscriptionModal(false)
    }, 400)
  }

  return (
    <div
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        opacity: show ? 1 : 0,
        transition: 'opacity 0.4s ease',
      }}
      className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
    >
      <div
        style={{
          transform: show ? 'scale(1)' : 'scale(0.9)',
          opacity: show ? 1 : 0,
          transition: 'all 0.4s ease',
        }}
        className=" w-full flex justify-center "
      >
        <div className="mt-6 xl:mt-[115px] flex flex-col items-center w-full z-10">
          <div className="flex items-center ">
            <BackIconImg onClick={handleClose} imgClass="cursor-pointer" />
            <p className="mb-0 text-white xl:text-[28px] font-bold ml-3 lg:ml-8">
              {t('choose_membership_plans_caps')}
            </p>
          </div>
          <p style={{ color: '#b5b5b5' }} className="mb-0 text-xs lg:text-sm italic mt-2 lg:mt-0">
            {t('choose_plan_that_works_friends')}
          </p>
          <div className="mt-4 w-[94%] lg:w-[905px]">
            <Subscription />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(SubscriptionModal)
